import React from "react";

const StatusCircle = ({ size, status, text }) => {
  // status can be 'w', 'l', 'd', or 'none'
  const statusClass = `si-status-${status.toLowerCase()}`;

  return (
    <div
      className={`si-status-circle ${statusClass}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${size * 0.5}px`, // Proportional font size
      }}
    >
      {text}
    </div>
  );
};

export default StatusCircle;
